import { connect } from 'react-redux';
import { compose, renderNothing, branch } from 'recompose';
import moment from 'moment';

import { extendedHourlyWagesEnabled } from '../../timeTracker/selectors';
import { isBrandViewActive } from '../../../auth/selectors';
import withDefaultEndingDate from '../filters/containers/withDefaultEndingDate';
import DownloadPaylocityReportButton from './components/DownloadPaylocityReportButton';

const mapStateToProps = (state, ownProps) => ({
  paylocityReportEnabled: isBrandViewActive(state) && extendedHourlyWagesEnabled(state),
  startDate: moment(ownProps.endingDateMax).add(-13, 'd').toDate(),
  endDate: ownProps.endingDateMax,
});

export default compose(
  withDefaultEndingDate(),
  connect(mapStateToProps),
  branch(
    props => !props.paylocityReportEnabled,
    renderNothing,
  ),
)(DownloadPaylocityReportButton);
